import {
  SalesContact,
} from "../../redux/api/api.types";
import InstanceContactRow from "./InstanceContactRow"

export default function InstanceSellerTableRow (entry: SalesContact) {
  const {sales_email: rowEmail, sales_firstname: rowFirst, sales_lastname: rowLast} = entry
  return InstanceContactRow({rowEmail, rowFirst, rowLast})
}